/**
 * DCM-362: human labels for the enrollment/checklist statuses.
 * Unknown values fall back to a readable sentence case (underscores → spaces).
 */
export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    not_started: 'Not started',
    draft: 'Draft',
    pending_supervisor: 'Waiting for approval',
    approved: 'Approved',
    rejected: 'Returned',
    submitted: 'Submitted',
    sign_at_centre: 'Sign at the centre',
    superseded: 'Replaced',
  };
  if (Object.prototype.hasOwnProperty.call(map, status)) return map[status];
  if (!status) return '';
  // sentence case: first letter upper, rest lower
  const spaced = status.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}